export default __webpack_public_path__ + "static/media/Determinants.5fd2d678.pdf";